/* eslint-disable */

/** unique or primary key constraints on table "argo.material_quantity_kind" */
export enum ArgoMaterialQuantityKindConstraint {
  /** unique or primary key constraint on columns "id" */
  MaterialQuantityKindPkey = 'material_quantity_kind_pkey'
}

export enum ArgoMaterialQuantityKindEnum {
  /** Bulk material (not individually tracked, can be married multiple times to any number of assemblies) */
  Bulk = 'bulk',
  /** Distinct material (individually tracked, can only be married to one assembly) */
  Distinct = 'distinct'
}

/** select columns of table "argo.material_quantity_kind" */
export enum ArgoMaterialQuantityKindSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id'
}

/** update columns of table "argo.material_quantity_kind" */
export enum ArgoMaterialQuantityKindUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id'
}

